export const DISPLAY_DATE_FORMAT = 'DD/MMM/YYYY';

export const ORIGINATING_SOURCE_TRANSLATION_KEYS = {
  WEBFORM: 'webform',
  MANUAL_ENTRY: 'manualEntry'
};

export const MANUAL_ENTRY = 'MANUAL_ENTRY';
